"use client";

import { useState } from "react";
import { Send, CheckCircle2 } from "lucide-react";
import axios from "axios";

const PUBLIC_API =
  (process.env.NEXT_PUBLIC_LANDING_API_URL?.replace(/\/$/, "") || "http://localhost:3820/api/v1") + "/public";

type FormState = { name: string; phone: string; message: string };
const EMPTY: FormState = { name: "", phone: "", message: "" };

export default function FeedbackForm() {
  const [form, setForm] = useState<FormState>(EMPTY);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  function handleChange(
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${PUBLIC_API}/feedback`, {
        name: form.name,
        phone: form.phone,
        message: form.message,
      });
      setSubmitted(true);
    } catch {
      alert("Gửi góp ý thất bại. Vui lòng thử lại hoặc gọi trực tiếp 091 6253 399.");
    } finally {
      setLoading(false);
    }
  }

  if (submitted) {
    return (
      <div className="flex flex-col items-center justify-center gap-4 py-12 text-center">
        <CheckCircle2 size={56} className="text-emerald-400" />
        <h3 className="text-2xl font-bold text-white">Cảm ơn bạn!</h3>
        <p className="text-blue-200 max-w-sm">
          Chúng tôi đã nhận được góp ý của bạn và sẽ phản hồi sớm nhất có thể.
        </p>
        <button
          onClick={() => { setForm(EMPTY); setSubmitted(false); }}
          className="mt-2 text-sm text-blue-300 underline hover:text-white transition-colors"
        >
          Gửi góp ý khác
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-blue-200 mb-1">
            Họ và tên <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            name="name"
            required
            value={form.name}
            onChange={handleChange}
            placeholder="Nguyễn Văn A"
            className="w-full rounded-lg bg-blue-900/50 border border-blue-600/50 px-4 py-2.5 text-white placeholder-blue-400 focus:outline-none focus:border-blue-400 transition"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-blue-200 mb-1">
            Số điện thoại <span className="text-red-400">*</span>
          </label>
          <input
            type="tel"
            name="phone"
            required
            value={form.phone}
            onChange={handleChange}
            placeholder="09xx xxx xxx"
            className="w-full rounded-lg bg-blue-900/50 border border-blue-600/50 px-4 py-2.5 text-white placeholder-blue-400 focus:outline-none focus:border-blue-400 transition"
          />
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-blue-200 mb-1">
          Nội dung góp ý <span className="text-red-400">*</span>
        </label>
        <textarea
          name="message"
          required
          rows={4}
          value={form.message}
          onChange={handleChange}
          placeholder="Nhập góp ý, đặt câu hỏi hoặc yêu cầu báo giá..."
          className="w-full rounded-lg bg-blue-900/50 border border-blue-600/50 px-4 py-2.5 text-white placeholder-blue-400 focus:outline-none focus:border-blue-400 transition resize-none"
        />
      </div>
      <button
        type="submit"
        disabled={loading}
        className="inline-flex items-center gap-2 rounded-lg bg-white px-6 py-3 font-semibold text-[color:var(--brand-dark)] hover:bg-blue-50 disabled:opacity-60 transition shadow-lg"
      >
        {loading ? (
          <span className="inline-block h-4 w-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
        ) : (
          <Send size={16} />
        )}
        {loading ? "Đang gửi..." : "Gửi góp ý"}
      </button>
    </form>
  );
}
